import { Gender } from "../generated/api-client";

export const genderValues: Gender[] = [
    "Female",
    "Male",
    "Other",
];

export const genderLabels: Record<Gender, string> = {
    Female: "Femenino",
    Male: "Masculino",
    Other: "Otro",
};

export const genderOptions = genderValues.map(value => ({
    value,
    label: genderLabels[value],
}));
